import React from 'react'

import { modal } from '../../core/utilities/modal'
import { buildingControllerIntegration } from '../../core/controllers/BuildingControllerIntegration'
import { buildingCameraIntegration } from '../../core/controllers/BuildingCameraIntegration'
import { ptiAccessControlIntegration } from '../../core/controllers/PTIAccessControlIntegration'

export default class AddBuildingIntegrations extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            integrations: [
                'Rently',
                'Geist',
                'RTSP Camera',
                'PTI Access Control'
            ],
            selectedIntegration: 0,
            rentlyUsername: null,
            rentlyPassword: null,
            rentlyHubs: null,
            selectedLevel: 0,
            ipaddress: '',
            portnumber: '',
            uuid: '',
            rtsp: '',
            name: '',
            ptiUsername: '',
            ptiPassword: '',
            ptiFacilityName: ''
        }
    }

    componentDidMount() {
    }

    componentWillUnmount() {
    }

    componentWillUpdate(nextProps, nextState) {
    }

    didSelectIntegration(e) {
        this.setState({
            selectedIntegration: e.target.value
        });
    }

    didEnterRentlyPassword(e) {
        this.setState({
            rentlyPassword: e.target.value
        });
    }

    didEnterRentlyUsername(e) {
        this.setState({
            rentlyUsername: e.target.value
        });
    }

    validURL(str) {
        var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
            '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
            '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
            '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
            '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
            '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
        return !!pattern.test(str);
    }

    authenticateRently() {
        var self = this;
        rentlyIntegrationController.authenticate(this.state.rentlyUsername, this.state.rentlyPassword, function(response) {
            if(response.status == 'ok') {
                modal.showInfo("Successfully Authenticated with Rently!", "success", "top", "center");
                if(self.state.selectedIntegration === 'Rently') {
                    self.showRentlyHubs();
                }
            } else {
                modal.showInfo("Unable to authenticate!", "danger", "top", "center");
            }
        });
    }

    showRentlyHubs() {
        var self = this;
        rentlyIntegrationController.getHubs(function(response) {
            self.setState({rentlyHubs: response.data.hubs});
        });
    }

    selectedHub(e) {
        this.setState({
            selectedHub: e.target.value
        });
    }

    didSelectLevel(e) {
        this.setState({
            selectedLevel: e.target.value
        });
    }

    handleIpAddressChange(e) {
        this.setState({
            ipaddress: e.target.value
        });
    }

    handlePortNumberChange(e) {
        this.setState({
            portnumber: e.target.value
        });
    }

    handleUUIDChange(e) {
        this.setState({
            uuid: e.target.value
        });
    }

    handleRTSPChange(e) {
        this.setState({
            rtsp: e.target.value
        });
    }

    handleNameChange(e) {
        this.setState({
            name: e.target.value
        });
    }

    handlePTIUsernameChange(e) {
        this.setState({
            ptiUsername: e.target.value
        });
    }

    handlePTIPasswordChange(e) {
        this.setState({
            ptiPassword: e.target.value
        });
    }

    handlePTIFacilityChange(e) {
        this.setState({
            ptiFacilityName: e.target.value
        });
    }

    addHub() {
        var self = this;
        const selectedHub = this.state.selectedHub;
        const selectedLevel = this.state.selectedLevel;

        if(selectedLevel == 0) {
            modal.showInfo("What floor does this hub exist on?", "warning", "top", "center");
            return;
        } else if (selectedHub == null) {
            modal.showInfo("Select a hub to add!", "warning", "top", "center");
            return;
        }

        rentlyIntegrationController.addHub(selectedHub, selectedLevel, this.props.buildingId, function(response) {
            if(response.status && response.status === 409) {
                modal.showInfo("This hub is already being monitored!  Select a different hub.", "danger", "top", "center");
            } else {
                self.setState({
                    rentlyHubs: null,
                    selectedIntegration: 0,
                    selectedLevel: 0,
                    uuid: '',
                    rtsp: '',
                    name: ''
                });

                modal.showInfo("Successfully added hub!", "success", "top", "center");
            }
        });
    }

    saveGeistController() {
        var self = this;
        const ipAddress = this.state.ipaddress;
        const portNumber = this.state.portnumber;
        const selectedLevel = this.state.selectedLevel;
        const uuid = this.state.uuid;

        if (ipAddress == '') {
            modal.showInfo("Please enter an ip address!", "warning", "top", "center");
            return;
        } else if (!this.validURL(ipAddress)) {
            modal.showInfo("Please enter a valid ip address.  http://x.x.x.x", "warning", "top", "center");
            return;
        }else if (portNumber == '') {
            modal.showInfo("Please enter a port number!", "warning", "top", "center");
            return;
        } else if (uuid == '') {
            modal.showInfo("What is the device uuid?", "warning", "top", "center");
            return;
        } else if (selectedLevel == 0) {
            modal.showInfo("What floor does this controller exist on?", "warning", "top", "center");
            return;
        }

        buildingControllerIntegration.addController(ipAddress, portNumber, selectedLevel, this.props.buildingId, 'geist', uuid, function(response) {
            if(response.status && response.status === 404) {
                modal.showInfo("Unable to establish communication with this controller.  Make sure your information is entered correctly.", "danger", "top", "center");
            } else if(response.status == 'DUPLICATE') {
                modal.showInfo("This controller is already being monitored!", "danger", "top", "center");
            } else if(response.status == 'NOT FOUND') {
                modal.showInfo("This controller could not be located with that UUID!", "danger", "top", "center");
            } else {
                self.setState({
                    rentlyHubs: null,
                    selectedIntegration: 0,
                    selectedLevel: 0,
                    uuid: '',
                    rtsp: '',
                    name: ''
                });

                modal.showInfo("Successfully added controller!  Please wait a few moments to see it show up.", "success", "top", "center");

                self.props.reload();
            }
        });
    }

    savePTIAccessControl() {
        var self = this;
        const site_code = this.state.ptiFacilityName;
        const username = this.state.ptiUsername;
        const password = this.state.ptiPassword;
         if (username == '') {
            modal.showInfo("Please enter a username.", "warning", "top", "center");
            return;
        } else if (password == '') {
            modal.showInfo("Please enter a password.", "warning", "top", "center");
            return;
        } else if (site_code == '') {
            modal.showInfo("Please enter a site code", "warning", "top", "center");
            return;
        }

        ptiAccessControlIntegration.addPTISite(site_code, username, password, this.props.buildingId, function(response) {
            if(response.status && response.status === 404) {
                modal.showInfo("Unable to establish communication with this controller.  Make sure your information is entered correctly.", "danger", "top", "center");
            } else {
                self.setState({
                    rentlyHubs: null,
                    selectedIntegration: 0,
                    selectedLevel: 0,
                    uuid: '',
                    rtsp: '',
                    name: '',
                    ptiPassword: '',
                    ptiUsername: '',
                    ptiFacilityName: ''
                });

                modal.showInfo("Successfully added a PTI Access Control System!  Please wait a few moments to see it show up.", "success", "top", "center");
                self.props.reload();
            }
        });
    }

    saveRTSPCamera() {
        var self = this;
        const selectedLevel = this.state.selectedLevel;
        const rtsp = this.state.rtsp;
        const name = this.state.name;

        if (name == '') {
            modal.showInfo("Please provide a camera name.", "warning", "top", "center");
            return;
        } else if (rtsp == '') {
            modal.showInfo("Please provide an RTSP url.", "warning", "top", "center");
            return;
        } else if (selectedLevel == 0) {
            modal.showInfo("What floor does this camera exist on?", "warning", "top", "center");
            return;
        }

        buildingCameraIntegration.addCamera(name, rtsp, selectedLevel, this.props.buildingId, 'camera', function(response) {
            if(response.status && (response.status === 404 || response.status === 409)) {
                modal.showInfo("Unable to add camera", "danger", "top", "center");
            } else {
                self.setState({
                    rentlyHubs: null,
                    selectedIntegration: 0,
                    selectedLevel: 0,
                    uuid: '',
                    rtsp: '',
                    name: ''
                });

                modal.showInfo("Successfully added camera!  Please wait a few moments to see it show up.", "success", "top", "center");

                self.props.reloadCameras();
            }
        });
    }

    generateFloorLevels() {
        let levelOptions = []

        for (let i = 0; i < this.props.levelCount; i++) {
            const level = i + 1;
            levelOptions.push(<option value={level}>Level {level}</option>);
        }

        return levelOptions;
    }

    render(){
        const integrationType = this.state.selectedIntegration;
        const integrations = this.state.integrations;
        const rentlyHubs = this.state.rentlyHubs;
        const rentlyPassword = this.state.rentlyPassword;
        const rentlyUsername = this.state.rentlyUsername;
        const ipaddress = this.state.ipaddress;
        const portnumber = this.state.portnumber;
        const uuid = this.state.uuid;
        const rtsp = this.state.rtsp;
        const name = this.state.name;
        const ptiFacilityName = this.state.ptiFacilityName;
        const ptiPassword = this.state.ptiPassword;
        const ptiUsername = this.state.ptiUsername;

        if(rentlyHubs != null) {
            return (
                <div class="card">
                    <div class="header">
                        <h4 class="card-icon-title"><span class="card-box-icon blue-card-icon-circle"><i class="pe-7s-plug"></i></span> Add Integrations</h4>
                    </div>
                    <div class="content">
                        <div class="row">
                            <div>
                                <div class="header">
                                    <p class="category">Select a Hub to load that information into this building.</p>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <select class="form-control" onChange={this.selectedHub.bind(this)}>
                                            <option value="0">Select Hub</option>
                                            {rentlyHubs.map(function(hub, index) {
                                                return (<option key={index} value={hub.id}>{hub.home_name}</option>)
                                            })}
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <select class="form-control" onChange={this.didSelectLevel.bind(this)}>
                                            <option value="0">What floor is this hub on?</option>
                                            {this.generateFloorLevels()}
                                        </select>
                                    </div>
                                </div>
                                <div class="col-sm-12">
                                    <button type="button" id="authenticate" data-loading-text="Loading..." class="btn btn-primary btn-warning btn-fill pull-left" autoComplete="off" onClick={this.addHub.bind(this)}>
                                    Add Hub
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )
        } else {
            return (
                <div class="card">
                    <div class="header">
                        <h4 class="card-icon-title"><span class="card-box-icon blue-card-icon-circle"><i class="pe-7s-plug"></i></span> Add Integrations</h4>
                    </div>
                    <div class="content">
                        <div class="row">
                            <div class="form-group">
                                <div class="col-sm-12">
                                <select class="form-control" onChange={this.didSelectIntegration.bind(this)} value={integrationType}>
                                    <option value="0">Select integration type</option>
                                    {integrations.map(function(integration, index) {
                                        return (<option key={index} value={integration}>{integration}</option>)
                                    })}
                                </select>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            {integrationType === 'Rently' && (
                                <div>
                                    <div class="header">
                                        <p class="category">First we need to authenticate with Rently.</p>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label for="username">Username</label>
                                            <input type="text" value="" class="form-control" name="username" placeholder="" id="username" value={rentlyUsername} onChange={this.didEnterRentlyUsername.bind(this)}/>
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label for="password">Password</label>
                                            <input type="password" value="" class="form-control" name="password" placeholder="" id="password" value={rentlyPassword} onChange={this.didEnterRentlyPassword.bind(this)}/>
                                        </div>
                                    </div>
                                    <div class="col-sm-12">
                                        <button type="button" id="authenticate" data-loading-text="Loading..." class="btn btn-primary btn-warning btn-fill pull-left" autoComplete="off" onClick={this.authenticateRently.bind(this)}>
                                        Authenticate
                                        </button>
                                    </div>
                                </div>
                            )}
                            {integrationType === 'Geist' && (
                                <div>
                                    <div class="header">
                                        <p class="category">Geist Controller Information</p>
                                    </div>
                                    <div class="col-md-8">
                                        <div class="form-group">
                                            <label for="username">IP Address</label>
                                            <input type="text" value="" class="form-control" placeholder="http://0.0.0.0" id="ipaddress" value={ipaddress} onChange={this.handleIpAddressChange.bind(this)}/>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label for="password">Port Number</label>
                                            <input type="text" value="" class="form-control" placeholder="0000" id="port" value={portnumber} onChange={this.handlePortNumberChange.bind(this)}/>
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label for="password">Controller UUID</label>
                                            <input type="text" value="" class="form-control" placeholder="0000" id="port" value={uuid} onChange={this.handleUUIDChange.bind(this)}/>
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <select class="form-control" onChange={this.didSelectLevel.bind(this)}>
                                                <option value="0">What level is this controller on?</option>
                                                {this.generateFloorLevels()}
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-sm-12">
                                        <button type="button" data-loading-text="Loading..." class="btn btn-primary btn-warning btn-fill pull-left" autoComplete="off" onClick={this.saveGeistController.bind(this)}>
                                        Integrate
                                        </button>
                                    </div>
                                </div>
                            )}
                            {integrationType === 'RTSP Camera' && (
                                <div>
                                    <div class="header">
                                        <p class="category">IP Cameras that are RTSP Enabled</p>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label for="password">Name</label>
                                            <input type="text" value="" class="form-control" placeholder="Front Office" id="name" value={name} onChange={this.handleNameChange.bind(this)}/>
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label for="password">RTSP URL</label>
                                            <input type="text" value="" class="form-control" placeholder="rtsp://username:password@host:port/subroute" id="rtsp" value={rtsp} onChange={this.handleRTSPChange.bind(this)}/>
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <select class="form-control" onChange={this.didSelectLevel.bind(this)}>
                                                <option value="0">What level is this camera on?</option>
                                                {this.generateFloorLevels()}
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-sm-12">
                                        <button type="button" data-loading-text="Loading..." class="btn btn-primary btn-warning btn-fill pull-left" autoComplete="off" onClick={this.saveRTSPCamera.bind(this)}>
                                        Integrate
                                        </button>
                                    </div>
                                </div>
                            )}
                            {integrationType === 'PTI Access Control' && (
                                <div>
                                    <div class="header">
                                        <p class="category">PTI Access Control Integration</p>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label for="username">Username</label>
                                            <input type="text" value="" class="form-control" placeholder="Username" id="username" value={ptiUsername} onChange={this.handlePTIUsernameChange.bind(this)}/>
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label for="password">Password</label>
                                            <input type="text" value="" class="form-control" placeholder="Password" id="password" value={ptiPassword} onChange={this.handlePTIPasswordChange.bind(this)}/>
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label for="name">Site Code</label>
                                            <input type="text" value="" class="form-control" placeholder="Redwood Apartments" id="name" value={ptiFacilityName} onChange={this.handlePTIFacilityChange.bind(this)}/>
                                        </div>
                                    </div>
                                    <div class="col-sm-12">
                                        <button type="button" data-loading-text="Loading..." class="btn btn-primary btn-warning btn-fill pull-left" autoComplete="off" onClick={this.savePTIAccessControl.bind(this)}>
                                        Integrate
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )
        }
    }
};


// WEBPACK FOOTER //
// app/components/Building/AddBuildingIntegrations.jsx